// summaryBuilder.ts

import { ProjectBaselineResponse, ProjectBaselineDetail } from "../interfaces/baselineInterface";

export const buildSummaryRows = (
    allBaselineData: ProjectBaselineResponse | null,
    allUpdatedRows: ProjectBaselineDetail[],
    ForecastDisplayType: any
): ProjectBaselineDetail[] => {

    if (!allBaselineData) return [];

    const allRows: ProjectBaselineDetail[] = [];

    allBaselineData.projects.forEach(project => {
        const proposalGroups = [
            { proposals: project.definiteProposals || [], type: ForecastDisplayType.LiveDefinite },
            { proposals: project.proposedProposals || [], type: ForecastDisplayType.LiveProposed },
            { proposals: project.thridPartyProposals || [], type: ForecastDisplayType.ThirdPartyCost },
        ];

        proposalGroups.forEach(group => {
            group.proposals.forEach(proposal => {
                proposal.categories?.forEach(cat => {
                    cat.subcategories?.forEach(sub => {
                        sub.feestages?.forEach(fs => {
                            fs.forecasts?.forEach(f => {
                                const updated = allUpdatedRows.find(
                                    u =>
                                        u.ProjectID === project.projectId &&
                                        u.FeeStageID === fs.feestageID &&
                                        new Date(u.BaselineMonth).getMonth() === new Date(f.monthDate).getMonth() &&
                                        new Date(u.BaselineMonth).getFullYear() === new Date(f.monthDate).getFullYear()
                                );

                                allRows.push({
                                    ProjectID: project.projectId,
                                    ProposalID: proposal.proposalID,
                                    FeeStageID: fs.feestageID,
                                    FeeStageReferenceNumber: fs.feeStageReferenceNumber,
                                    CategoryID: cat.categoryID,
                                    SubCategoryID: sub.subcategoryID,
                                    ProposalNumber: proposal.proposalNumber,
                                    ProposalDescription: proposal.proposalDescription,
                                    BaselineMonth: f.monthDate,

                                    BaselineValue: updated ? updated.BaselineValue : f.forecastValue,
                                    ForeCastOldValue: updated ? updated.ForeCastOldValue : f.forecastValue,

                                    Outstanding: fs.outstanding,
                                    StartDate: project.startDate,
                                    EndDate: project.endDate,
                                    BaseLineDisplayType: group.type,
                                });
                            });
                        });
                    });
                });
            });
        });
    });

    return allRows;
};
